module.exports = __webpack_public_path__ + "static/media/en.d3fc3c17.svg";